import React, { useState } from 'react'
import { Form, FormControl, Modal, Spinner } from 'react-bootstrap'
import Selector from '../ui/Selector'
import {
	OptionsRes,
	PostNewOptionReq,
	RuleReq,
	SelectOption,
	translatedKeys,
} from '../types'
import Button from 'react-bootstrap/Button'
import useTheme from '../hooks/useTheme'
import {langs, otherVariantsLimit} from '../constants'

interface Props {
	isOpen: boolean
	onClose: () => void
	save: (data: PostNewOptionReq) => void
	isLoading: boolean
}

const AddOptionModal: React.FC<Props> = ({
	isOpen,
	onClose,
	isLoading,
	save,
}) => {
	const theme = useTheme()
	const [selectCategory, setSelectCategory] = useState<SelectOption | null>(
		null,
	)
	const [code, setCode] = useState('')
	const [name, setName] = useState('')
	const [otherVariants, setOtherVariants] = useState<
		{ lang: string; name: string }[]
	>([])

	const handleSave = () => {
		save({
			params: {
				option: selectCategory?.value || '',
			},
			data: {
				code,
				name,
				otherVariants,
			},
		})
	}

	return (
		<Modal
			style={{ '--bs-modal-color': 'var(--bs-body-color)' } as any}
			data-bs-theme={theme}
			centered
			show={isOpen}
			onHide={onClose}
		>
			<div>
				<Modal.Header closeButton>
					<Modal.Title data-bs-theme={theme}>Додати категорію</Modal.Title>
				</Modal.Header>

				<Modal.Body>
					<div className="d-flex align-items-center justify-content-center">
						<div style={{ flex: 1 }}>
							<Form.Group className="mb-3">
								<Selector
									value={selectCategory}
									onChange={(val) => setSelectCategory(val)}
									options={Object.keys(translatedKeys).map((i) => ({
										value: i,
										// @ts-ignore
										label: translatedKeys[i],
									}))}
								/>
							</Form.Group>
							<Form.Group className="mb-3">
								<Form.Label>Код</Form.Label>
								<FormControl
									value={code}
									onChange={(e) => setCode(e.target.value)}
									placeholder="Код"
								/>
							</Form.Group>
							<Form.Group className="mb-3">
								<Form.Label>Назва</Form.Label>
								<FormControl
									value={name}
									onChange={(e) => setName(e.target.value)}
									placeholder="Назва"
								/>
							</Form.Group>
							<Form.Group className="mb-3">
								<Form.Label>Варіанти</Form.Label>
								{otherVariants.map((variant, index) => (
									<div
										className="d-flex align-items-center gap-1 p-1"
										key={index}
									>
										<Form.Select
											style={{ width: '80px' }}
											size="sm"
											value={variant.lang}
											onChange={(e) => {
												const newLang = e.target.value
												const newVariants = otherVariants.map(
													(v, langIndex) => {
														if (langIndex === index) {
															return {
																...v,
																lang: newLang,
															}
														} else {
															return v
														}
													},
												)
												setOtherVariants(newVariants)
											}}
										>
											{langs.map((lang) => (
												<option key={lang} value={lang}>
													{lang}
												</option>
											))}
										</Form.Select>
										<Form.Control
											size="sm"
											value={variant.name}
											onChange={(e) => {
												const newName = e.target.value
												setOtherVariants((prevVariants) => {
													if (prevVariants) {
														return prevVariants.map((v, nameIndex) =>
															nameIndex === index ? { ...v, name: newName } : v,
														)
													}
													return prevVariants
												})
											}}
										/>
										<Button
											variant="danger"
											size="sm"
											onClick={() => {
												const newVariants = otherVariants.filter(
													(v, deleteIndex) => deleteIndex !== index,
												)
												setOtherVariants(newVariants)
											}}
										>
											Видалити
										</Button>
									</div>
								))}
								{otherVariants.length < otherVariantsLimit && (
									<Button
										className="m-1"
										size="sm"
										onClick={() => {
											const newVariants = [
												...otherVariants,
												{
													lang: langs[0],
													name: '',
												},
											]
											setOtherVariants(newVariants)
										}}
									>
										Додати варіант
									</Button>)
								}
							</Form.Group>
						</div>
					</div>
				</Modal.Body>

				<Modal.Footer>
					<Button onClick={onClose} variant="secondary">
						Закрити
					</Button>
					<Button
						disabled={
							!(code && name && selectCategory) ||
							isLoading
						}
						onClick={handleSave}
						variant="primary"
					>
						Додати
						{isLoading && (
							<Spinner className="ms-1" animation="border" size="sm" />
						)}
					</Button>
				</Modal.Footer>
			</div>
		</Modal>
	)
}

export default AddOptionModal
